/* External */
import { useLocation } from 'react-router-dom';

/* Ott-common */
import { PlaybackHeartbeatController } from '@dtvgo/player-utils';
import { TimeCounter } from '@dtvgo/utils';

/* Utils */
import backendService from '~/services/backendService';
import useRefInit from '~/hooks/useRefInit';
import { getDeviceId } from '~/utils/deviceIdUtils';
import { useUserAccount } from '~/providers/UserProvider';
import { PLAY_SOURCE_PAGE } from '~/utils/trackSourceConviva';
import {
  PLAYER_HEARTBEAT_TIME_MINUTES,
  USE_STREAMING_V4,
  isLearnActionV4Active,
} from '~/utils/env';

export default function usePlaybackHeartbeatController() {
  const {
    msoProvider,
    accountType: userType,
  } = useUserAccount() || {};

  const { state: locationState } = useLocation();
  const { actionOrigin } = locationState;

  const streamedTimeCounter = useRefInit(() => new TimeCounter());
  const streamedContentTimeCounter = useRefInit(() => new TimeCounter());
  const playbackHeartbeatController = useRefInit(() => (
    new PlaybackHeartbeatController({
      backendService,
      heartbeatTimeInSeconds: PLAYER_HEARTBEAT_TIME_MINUTES * 60,
      deviceId: getDeviceId(),
      useStreamingV4: USE_STREAMING_V4,
      useStopV4: isLearnActionV4Active,
      actionOrigin: actionOrigin || '',
      userOrigin: {
        playSource: PLAY_SOURCE_PAGE.PLAYER,
        userLogin: userType,
        msoProvider,
      },
      getStreamedTime: () => streamedTimeCounter.getElapsedSeconds(),
      getStreamedContentTime: () => streamedContentTimeCounter.getElapsedSeconds(),
    })
  ));

  return {
    playbackHeartbeatController,
    streamedContentTimeCounter,
    streamedTimeCounter,
  };
}
